<template>
  <div class="field">
    <label class="label">{{ $t("Template") }}</label>
    <button
      class="button is-primary is-outlined template-button-width"
      :class="{ 'is-danger': errors.length > 0 }"
      @click="handleClick"
    >
      <span class="icon is-left"><i class="fa" :class="icon"/></span>
      <span class="text">{{ value }}</span>
    </button>
    <p class="help is-danger" v-if="errors && errors.length > 0">
      {{ $t(errors[0]) }}
    </p>
  </div>
</template>

<script>
export default {
  name: "button-field",
  props: ["value", "label", "errors", "click", "icon"],
  methods: {
    handleClick() {
      this.$emit("click")
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  width: 100%;
  .text {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
